<template>
  <div class="tabers relative">
    <img class="absolute at0 ar0 al0 ab0 w100 h100 ovhi" src="@/assets/bottoms.png"  />
    <div :class="ispc?'bodys':''" class="relative zi10">
      <img @click="pageChange('/')" class="tabers_mains_logos cur_po" src="@/assets/bottoms-logos.png"  />
      <div class="tabers_mains_lefts_lines_texts spacing">
        地址：{{ webinfo.address }}
      </div>
      <div class=" flex flex-row-between relative">
        <div class="tabers_mains_lefts">
          <div class="tabers_mains_lefts_lines_texts spacing">
            邮箱：{{ webinfo.email }}
          </div>
          <div class="tabers_mains_lefts_lines_texts spacing">
            电话：{{ webinfo.mobile }}
          </div>
          <div class="tabers_mains_lefts_lines_texts cur_po spacing" @click="pageChange1(1)">
            备案号：{{ webinfo.beian }}
          </div>
          <div class="tabers_mains_lefts_lines_texts spacing cur_po flex flex-col-center " @click="pageChange1(3)">
            <img class="tabers_mains_beian" src="@/assets/gong.png"  />
            晋公网安备14010502990207号
          </div>
          <div
            @click="pageChange1(2)"
            class="tabers_mains_lefts_lines_texts cur_po spacing"
          >
            技术支持：科辉荣盛
          </div>
        </div>
        <img
          class="tabers_mains_rights_images absolute  ar0 "
          :src="baseUrls + webinfo.qrcode"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, watch, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const { proxy } = getCurrentInstance(); //关键代码
import { useStore } from "vuex";
const store = useStore();
const baseUrls = computed(() => store.state.baseUrls);
const ispc = computed(() => store.state.ispc);

const webinfo = ref({});
const getjoinusindex = () => {
  proxy.request("servearea/joinusindex", {}).then((res) => {
    webinfo.value = res.data.webinfo;
  });
};
getjoinusindex();
const pageChange1 = (types) => {
  const aTag = document.createElement("a");
  aTag.target = "_blank";
  if (types == 2) {
    aTag.href = "http://www.bjkhrs.com/";
  } 
  if (types == 1) {
    aTag.href = "https://beian.miit.gov.cn/#/Integrated/index";
  }
  if (types == 3) {
    aTag.href = "https://beian.mps.gov.cn/#/query/webSearch?code=14010502990207";
  }
  aTag.click();
};
const pageChange = (urls) => {
  window.scrollTo(0, 0);
  router.push(urls);
};
</script>

<style>
@media screen and (max-width: 768px) {
  .tabers {
    padding: 55rem 30rem 70rem;
  }
  .tabers_mains_logos{
    height: 40rem;
    margin: 0 0 40rem 0;
  }
  .tabers_mains_beian{
    height: 30rem;
    margin: 0 10rem 0 0;
  }
  .tabers_mains_lefts_lines_texts {
    font-size: 24rem;
    color: #333333;
    padding: 0 0 10rem;
  }
  .tabers_mains_rights_images {
    width: 170rem;
    height: 170rem;
  }
}
@media screen and (min-width: 768px) {
  .tabers {
    padding: 40px 0;
  }
  .tabers_mains_logos{
    height: 35px;
    margin: 0 0 20px 0;
  }
  .tabers_mains_beian{
    height: 20px;
    margin: 0 10px 0 0;
  }
  .tabers_mains_lefts_lines_texts {
    font-size: 16px;
    color: #333333;
    padding: 3px 0;
  }
  .tabers_mains_rights_images {
    width: 135px;
    height: 135px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
}
@media screen and (min-width: 1200px) and (max-width: 1700px) {
}
@media screen and (min-width: 1700px) {
}
</style>
